import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import {errorMessage} from "@awe-web/shared/lib";
import {dismissError} from "@awe-web/shared/lib";
import {Translation as T} from "@awe-web/shared/lib";
import {Overlay, OverlayHeading, OverlaySection} from "../../components/overlay.js";
import {Button} from "../../components/form.js";

import "./error_overlay.scss";

const AN_ERROR_OCCURED = "FSD0000312";
const CLOSE_OVERLAY = "FSD0000313";

export default function ErrorOverlay() {
  const dispatch = useDispatch();

  const errorMsg = useSelector((state) => errorMessage(state));

  const onClose = useCallback(() => {
    dispatch(dismissError());
  }, [dispatch]);

  return (
    <Overlay className="error-overlay" open={Boolean(errorMsg)} onClose={onClose}>
      {({closeOverlay}) => (
        <>
          <OverlayHeading><T code={AN_ERROR_OCCURED} /></OverlayHeading>
          <OverlaySection>
            <div className="error-overlay__message">
              {errorMsg}
            </div>
            <Button className="error-overlay__button" primary continue onClick={closeOverlay}>
              <T code={CLOSE_OVERLAY} />
            </Button>
          </OverlaySection>
        </>
      )}
    </Overlay>
  );
}
